import { render } from "./ppt.vue?vue&type=template&id=124f5245"
const script = {}
script.render = render

export default script